
import { MsalService, MsalGuard, BroadcastService } from '@azure/msal-angular';
import { MSALServiceProvider } from './msal-service-provider';
import { Router } from '@angular/router';
import { AppConfigService } from './app-config.service';

export function AuthenticationFactory(appConfigService: AppConfigService, 
                                        msalService: MsalService, 
                                        msalGuard: MsalGuard,
                                        router: Router,
                                        broadcastService: BroadcastService
                                        ) {

     return new MSALServiceProvider(msalService, appConfigService, msalGuard, broadcastService);
  
}

